import * as nav from './views/nav';
import * as passwordCreate from './views/password-create';
import * as passwordReset from './views/password-reset';
import * as signin from './views/signin';
import * as signup from './views/signup';